import type { CreateEmulatorRequest, CreateEmulatorResponse } from "@repo/sdk/types";
import {
  useHttpConfig,
  useHttpMutation,
  type HttpMutationConfiguration,
} from "@repo/utils/hooks";
import { useCtrlClient } from "../contexts/CtrlApiProvider";

export function useCreateEmulator(
  config?: HttpMutationConfiguration<
    CreateEmulatorResponse,
    Error,
    string,
    CreateEmulatorRequest
  >
) {
  const client = useCtrlClient();
  const { mutate } = useHttpConfig();

  return useHttpMutation<
    CreateEmulatorResponse,
    Error,
    string,
    CreateEmulatorRequest
  >(
    "emulators/create",
    async (_key, { arg: params }) => {
      const response = await client.createEmulator(params);

      await mutate("emulators");

      return response;
    },
    config
  );
}
